import styled from "@emotion/styled";
import { Typography } from "@mui/material";

export const DlspTitleTypography = styled(Typography)(({theme}) => ({
    fontVariant: 'all-small-caps',
    padding: '0.25rem 0.5rem',
    fontSize: '2rem',
    margin: '-8px -8px 0.5rem -8px',
    borderBottom: '1px solid #c1c1c1',
    borderRadius: '5px 5px 0 0',
    backgroundColor: '#e7e3e1'
}));